import React from 'react';
import { Row, Col } from 'antd';
import { PhotoImage, PhotoPlaceholder } from "../photoImage/photoImage";
import './pastorCard.css';

export const PastorCard = ({pastor}) => {
  return(
    <Row className="church-profile-pastors__row">
      <Col span={3}>
        { pastor.photo.small ? <PhotoImage imageURL={pastor.photo.small}/> : <PhotoPlaceholder/> }
      </Col>
      <Col offset={4}>
        <div className="church-profile-pastors__name-block">
          <b>Pastor { pastor.name } { pastor.currentUserLabel } { pastor.confirmationLabel }</b>
          <p>{ pastor.roleLabel }</p>
        </div>
        <div className="church-profile-pastors__info-block">
          <p>{ pastor.department }</p>
          <p><a href={`mailto:${pastor.email}`}>{pastor.email}</a></p>
          <p>{ pastor.phone }</p>
        </div>
      </Col>
    </Row>
  );
};



// WEBPACK FOOTER //
// ./src/components/common/pastorCard/pastorCard.js